import type { SubmitEvent } from 'react'
import {
  VpIcon,
  VpIconButton,
  VpInput,
  VpInputField,
} from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'

interface FiltersBarCodeSearchProps {
  label: string
  value: string
  onChange: (value: string) => void
  onSubmit: (event: SubmitEvent<HTMLFormElement>) => void
  onClear: () => void
}

export function FiltersBarCodeSearch({ label, value, onChange, onSubmit, onClear }: Readonly<FiltersBarCodeSearchProps>) {
  const { t } = useTranslation()

  return (
    <form
      className="products-gallery__filters-bar__code-search"
      role="search"
      aria-label={label}
      onSubmit={onSubmit}
    >
      <label className="sr-only" htmlFor="input-products-gallery-code-search">
        {label}
      </label>
      <VpInput
        id="products-gallery-code-search"
        name="product_code"
        value={value}
        onChange={event => onChange(event.target.value)}
        placeholder={label}
        startSlot={<VpIcon name="search" aria-hidden="true" />}
        endSlot={(
          <VpIconButton
            size="small"
            variant="ghost"
            aria-label={t('close')}
            onClick={onClear}
          >
            <VpIcon name="close" aria-hidden="true" />
          </VpIconButton>
        )}
        fieldSlot={<VpInputField />}
        size="small"
      />
    </form>
  )
}
